/**
 * 政采贷 申请信息
 */
import request from '../request2'

const zcdApplyInfoApi = Object.assign({}, {baseUrl: '/ccjtLoan/zcdApplyInfo'})

zcdApplyInfoApi.list = function ({params, page}) {
  return request({
    url: `/ccjtLoan/zcdApplyInfo/list/` + page.pageNo + '/' + page.pageSize,
    method: 'post',
    data: params
  })
}

zcdApplyInfoApi.detail = function (id) {
  return request({
    url: `/ccjtLoan/zcdApplyInfo/detail/` + id,
    method: 'get',
  })
}

zcdApplyInfoApi.delete = function (id) {
  return request({
    url: `/ccjtLoan/zcdApplyInfo/delete/` + id,
    method: 'delete',
  })
}

zcdApplyInfoApi.update = function (data) {
  return request({
    url: `/ccjtLoan/zcdApplyInfo/update`,
    method: 'put',
    data
  })
}
zcdApplyInfoApi.add = function (data) {
  return request({
    url: `/ccjtLoan/zcdApplyInfo/add`,
    method: 'post',
    data: data
  })
}
zcdApplyInfoApi.completeZcdTask = function (data) {
  return request({
    url: `/ccjtLoan/zcdApplyInfo/completeZcdTask`,
    method: 'put',
    data
  })
}
zcdApplyInfoApi.startZcdTask = function (productId) {
  return request({
    url: `/ccjtLoan/zcdApplyInfo/startZcdTask/${productId}`,
    method: 'post',
    data: {}
  })
}
zcdApplyInfoApi.getZcdTaskButton = function (processInstanceId) {
  return request({
    url: `/ccjtLoan/zcdApplyInfo/getZcdTaskButton/${processInstanceId}`,
    method: 'post',
    data: {}
  })
}


export default zcdApplyInfoApi
